"use client";

import { trackEvent } from "@/utils/analytics/track-event";
import { useEffect } from "react";

interface ProjectPageTrackingProps {
	projectId: string;
	projectName: string;
}

export function ProjectPageTracking({ projectId, projectName }: ProjectPageTrackingProps) {
	useEffect(() => {
		// Track project page view
		trackEvent({
			facebook: {
				event: "ViewContent",
				options: {
					content_type: "home_listing",
					content_ids: [projectId],
					content_name: projectName,
					city: "Bangalore",
				},
			},
			google: {
				event: "view_item",
				options: {
					currency: "INR",
					items: [
						{
							item_id: projectId,
							item_name: projectName,
							item_category: "project",
							quantity: 1,
						},
					],
				},
			},
			matomo: {
				event: "view-project",
				options: {
					category: "property",
				},
			},
		});
	}, [projectId, projectName]);

	return null;
}
